<template>
  <div class="fzmOrderCheckout fzmOrderSummary">

    <div class="orderCheckoutBody">
        <div class="container">
            <div class="row">
                <div class="col-lg-5">
                    <img src="@/assets/img/orderSummaryImage.png" alt="">
                </div>

                <div class="col-lg-6 offset-lg-1">
                    <button 
                        @click="backtopreviouspage" 
                        class="btn btn-primary backbtn">Back</button>
                    
                    <div class="orderCheckoutHeader">
                        <div class="row">
                            <div class="col-6">
                                <template v-if="!issubscription">
                                    <h1>Holes Event</h1>
                                </template>

                                <template v-else>
                                    <h1>12 Count Holes Donuts</h1>
                                </template>
                            </div>

                            <div class="col-6">
                                <button 
                                    @click.prevent="$router.push({name : 'payment'})"
                                    class="btn btn-primary btn-right">

                                    Continue to Payment
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="orderSummaryBreakdown">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>
                                        ORDER SUMMARY
                                    </th>

                                    <th>
                                        TOTAL
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                

                                <template v-if="issubscription">
                                    <template v-for="(order, index) in orderboxesgroup">
                                        <tr :key="index">
                                            <td>
                                                <h2>{{order.count > 1 ? `(${order.count}) Dozen of` : ''}} {{order.box_name}}</h2>
                                                <p>{{getflavors(order.flavors)}}</p>
                                            </td>

                                            <td>
                                                <!-- ${{assortedbox.id == order.id ? order.count * getboxprice() : getboxprice() | decimal}} -->
                                                ${{order.count * getboxprice() | decimal}}
                                            </td>
                                        </tr>
                                    </template>
                                </template>

                                <template v-else>
                                    <tr >
                                        <td>
                                            <h2>{{orderboxes.length}} DOZEN DONUTS</h2>
                                            
                                            <template v-for="box in orderboxesgroup">
                                                <p :key="box.flavor">{{box.count}} Dozen - {{box.flavor}}</p>
                                            </template>
                                        </td>

                                        <td>
                                            ${{orderboxes.length * getboxprice() | decimal}}
                                        </td>
                                    </tr>
                                </template>


                                
                            </tbody>
                        </table>

                        <table class="table computationtable">
                            <tbody>
                                <tr class="summaryComputationRow">
                                    <td></td>

                                    <td class="summaryComputation">
                                        <div class="row">
                                            <div class="col-6">
                                                <span class="computationLabel">
                                                    Sub Total
                                                </span>
                                            </div>

                                            <div class="col-6">
                                                ${{ordersummary.subtotal}}
                                            </div>

                                            <div class="col-6">
                                                <span class="computationLabel">
                                                    Delivery
                                                </span>
                                            </div>

                                            <div class="col-6">
                                                ${{ordersummary.delivery}}
                                            </div>
                                            
                                            <div class="col-6">
                                                <span class="computationLabel">
                                                    Taxes
                                                </span>
                                            </div>

                                            <div class="col-6">
                                                ${{ordersummary.taxes}}
                                            </div>

                                            <div class="col-6 grandTotal">
                                                <span class="computationLabel">
                                                    TOTAL
                                                </span>
                                            </div>

                                            <div class="col-6 grandTotal">
                                                ${{ordersummary.grandtotal}}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
// mixins
import {ordermixins} from '@/mixins/ordermixins'
import {orderboxmixins} from '@/mixins/orderboxmixins'

export default {
    mixins    : [ordermixins, orderboxmixins],
    data() {
        return {
            /**
             * Grouping of order by flavors
             */
            orderboxesgroup: [],

        }
    },
    methods : {
        /**
         * Order for event 
         * get box type selected
         */
        getorderforeventboxtype() {
            const box = this.ordertypes.find(box => box.box_name.toLowerCase().indexOf(`${this.orderboxes.length}` && box.box_type == 'event'));
            this.orderboxtype = box;
        },
        /**
         * Order summary grouping
         * Group all same boxes and tally the total number
         */
        grouporderboxes() {
            if(!this.issubscription) {
                let order = [];

                this.orderboxes.forEach((box) => {
                    const flavor = box.id == this.assortedbox.id ? this.assortedbox.box_name : this.flavors.find(f => f.id == box.flavors[0]).name;
                    const exist = order.find(o => o.flavor == flavor);
                    if(exist) {
                        exist.count++; 
                    } else {
                        order = [...order, {
                            count   : 1,
                            type    : box.id,
                            box_name: box.box_name,
                            flavor  : flavor
                        }]
                    }
                });

                this.orderboxesgroup = order;
            } else {
                /**
                 * Subscription order grouping
                 * Group all assorted
                 */
                // this.orderboxes.forEach(o => {
                //     console.log('orderbox from checkout', o)
                // })

                const temporder = this.orderboxes.slice().map(o => {
                    o.flavors = o.flavors.map(f => {
                        console.log('ffffffff', f)
                        return {
                            id : f
                        }
                    })
                    
                    return o
                });


                console.log('temp order', temporder)
                
               
                let   order             = this.groupboxorder(temporder);

                this.orderboxesgroup = order;
            }
        },
        /**
         * Return to previous page
         * check if subscription or order for event
         */
        backtopreviouspage() {
            let route = 'product'

            if(!this.issubscription) {
                route = 'orderforevent'
            } 

            this.$router.push({name : route})    

        },
        /**
         * Get order flavors name
         * @returns {String} flavor name
         */
        getflavors(flavors) {
            console.log('flavors nanme', flavors)
            const fids = flavors.map(f => f.id)
            const flavs = this.flavors.filter(f => fids.includes(f.id)).map(f => f.name);
            return flavs.join(', ');
        }
    },
    /**
     * Run function before component render
     */
    beforeMount() {
        /**Group Order box by type or flavor */
        this.grouporderboxes();
        
        /**
         * get box price
         */
        this.getorderforeventboxtype();

    },
    /**
     * Run fucntion after component rendered
     */
    mounted() {
        
        /** Compute summary */
        this.computeordersummary();

      
    }
}
</script>

<style lang="scss">
@import '@/scss/global/_mixins.scss';

.fzmOrderCheckout {
    .backbtn {
        @include screen-up(lg) {
            margin-top : 30px;
        }
    }

    .computationtable {
        tr {
            td {
                width : 50%;
            }
        }
    }
}
</style>